import withModalControls, {
  WithModalControlsProps
} from '@anm/HOCs/withModalControls';
import Button, { ButtonProps } from '@anm/components/buttons/Button';
import { useEffect, useState, FC } from 'react';

import ShareDialog, { ShareDialogProps } from '../ShareDialog';

export type ShareButtonProps = Partial<ButtonProps> &
  WithModalControlsProps & {
    link: string;
    onShare?: ShareDialogProps['onShare'];
  };

const ShareButton: FC<ShareButtonProps> = ({
  link,
  openModal,
  closeModal,
  isModalOpened,
  onShare,
  ...otherProps
}) => {
  const [shareTitle, setShareTitle] = useState('');

  useEffect(() => {
    const canUpdate = shareTitle !== document.title;
    canUpdate && setShareTitle(document.title);
  });

  return (
    <>
      {isModalOpened && (
        <ShareDialog
          title={shareTitle}
          shareLink={link}
          onShare={onShare}
          onClose={closeModal}
        />
      )}
      <Button
        size="large_long_static"
        variant="white-blue-border-share"
        onClick={openModal}
        {...otherProps}
      >
        Share
      </Button>
    </>
  );
};

export default withModalControls(ShareButton);
